import React, { useState } from 'react'
import style from "./Configure.module.css"
import Header from "../Header/Header"
import Modal from "./Modal/Modal"

const Configure = () => {
  const [openModal, setOpenModal] = useState(false);
  return (
    <div className={style.config}>
      <div className={style.main__config}>
        <Header />
      </div>
      <div className={style.click}>
        <button className={style.glow_on_hover} onClick={()=> setOpenModal(true)}>Click to Configure</button>
        <Modal open={openModal}  onClose={() => setOpenModal(false)}/>
      </div>
    </div>
  )
}

export default Configure